import ReactGA from 'react-ga4';

/**
 * Service to handle Google Analytics operations.
 */
class AnalyticsService {
    /**
    * Initializes GA4 with the provided Measurement ID.
    * @param {string} id - The GA4 Measurement ID.
    */
    static initialize(id) {
        const measurementId = id || process.env.REACT_APP_GA_MEASUREMENT_ID;

        if (!measurementId) {
            console.warn('Google Analytics: Measurement ID is missing. Analytics tracking is disabled.');
            return;
        }

        try {
            const isLocalhost = Boolean(
                window.location.hostname === 'localhost' ||
                window.location.hostname === '[::1]' ||
                window.location.hostname.match(
                    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
                )
            );

            ReactGA.initialize(measurementId, {
                testMode: isLocalhost,
                gaOptions: {
                    debug_mode: isLocalhost,
                },
            });

            if (isLocalhost) {
                console.log('Google Analytics initialized in debug/test mode with ID:', measurementId);
            }
        } catch (error) {
            console.error('Failed to initialize Google Analytics:', error);
        }
    }

    /**
     * Records a page view.
     * @param {string} path - The path of the page viewed.
     */
    static trackPageView(path) {
        try {
            if (!ReactGA.isInitialized) return;
            ReactGA.send({ hitType: 'pageview', page: path });
        } catch (error) {
            console.error('Failed to track page view:', error);
        }
    }

    /**
     * Records a custom event.
     * @param {string} category - Event category (e.g., 'User').
     * @param {string} action - Event action (e.g., 'Login').
     * @param {string} label - Event label (Optional).
     * @param {number} value - Event value (Optional).
     */
    static trackEvent(category, action, label = '', value = 0) {
        try {
            if (!ReactGA.isInitialized) return;

            ReactGA.event({
                category,
                action,
                label,
                value,
            });
        } catch (error) {
            console.error('Failed to track event:', error);
        }
    }
}

export default AnalyticsService;
